import API from '@/api';
const Diagnosis = API.get('Diagnosis');
const Medicine = API.get('Medicine');

export default ({
  namespaced: true,
  state: {
    id: null,
    last_page: 0,
    
    code: '',
    description: '',
    impression: '',
    record_type: '',
    created_on: '',
    diagnosis_index: '',

    level: '',
    diagnoses: [],
    active: null,
    activeIndex: null,

    // CODES
    fave_codes: JSON.parse(localStorage.getItem('favorite_codes') || '{}'),
    used_codes: JSON.parse(localStorage.getItem('most_used_codes') || '{}'),
    codes: [],
    removed_items: []
  },

  /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

  getters: {
    last_page: state => state.last_page,
    code: state => state.code,
    description: state => state.description,
    impression: state => state.impression,
    record_type: state => state.record_type,
    created_on: state => state.created_on,
    diagnosis_index: state => state.diagnosis_index,
    
    // level: state => state.level,
    diagnoses: state => state.diagnoses,
    active: state => state.active,
    activeIndex: state => state.activeIndex,
    
    // CODES
    fave_codes: state => state.fave_codes,
    used_codes: state => state.used_codes,
    codes: state => state.codes,
    removed_items: state => state.removed_items
  },

  /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

  mutations: {

    setLastPage(state, last_page) {
      state.last_page = last_page
    },

    /* ############################# SEPARATOR ############################# */

    updateCode(state, code) {
      state.code = code
    },

    /* ############################# SEPARATOR ############################# */

    updateDescription(state, description) {
      state.description = description
    },

    /* ############################# SEPARATOR ############################# */

    updateImpression(state, impression) {
      state.impression = impression
    },

    /* ############################# SEPARATOR ############################# */

    add(state) {
      if (state.diagnoses.length >= 1) {
        state.diagnoses.forEach(e => {
          e.level = 'Secondary'
        });
      }

      let diagnosis_index = null;

      // work around with pagination issue
      if(state.diagnoses[state.diagnoses.length - 1]) {
        diagnosis_index = state.diagnoses[state.diagnoses.length - 1].diagnosis_index + 1;
      } else {
        diagnosis_index = 0;
      }

      var diagnosis = {
        id: null,
        code: state.code,
        description: state.description,
        impression: state.impression,
        created_on: null,
        record_type: 'current',
        
        // work around with pagination issue
        diagnosis_index
      }

      state.diagnoses.push(diagnosis)
    },

    /* ############################# SEPARATOR ############################# */

    edit(state) {
      var diagnosis = {
        id: state.id,
        code: state.code,
        description: state.description,
        impression: state.impression,
        record_type: state.record_type,
        level: state.level,
        diagnosis_index: state.diagnosis_index
      }

      state.diagnoses.splice(state.activeIndex, 1, diagnosis);
    },

    /* ############################# SEPARATOR ############################# */

    clear(state) {
      state.id = null
      state.code = ''
      state.description = ''
      state.impression = ''
      state.level = ''
      state.diagnosis_index = ''
    },

    /* ############################# SEPARATOR ############################# */

    setActive(state, index) {
      var diagnosis = state.diagnoses[index];
      state.id = diagnosis.id      
      state.code = diagnosis.code
      state.description = diagnosis.description
      state.impression = diagnosis.impression
      state.record_type = diagnosis.record_type
      state.diagnosis_index = diagnosis.diagnosis_index

      state.level = diagnosis.level
      state.activeIndex = index;
    },

    /* ############################# SEPARATOR ############################# */

    remove(state) {
      var index = state.activeIndex;
      var target = state.diagnoses.findIndex( diagnosis => diagnosis.diagnosis_index === index );

      if (target <= -1) {
        target = 0;
      }

      var item = state.diagnoses[target]
      if (item.id !== null) {
        state.removed_items.push(item)
      }
      state.diagnoses.splice(target, 1);
    },

    /* ############################# SEPARATOR ############################# */

    loadSavedData(state, diagnoses) {

      state.diagnoses = [];

      console.log("diagnoses from cases");
      console.log(diagnoses);

      diagnoses.forEach(async (diagnosis, index) => {
        const data = {
          id:           diagnosis.id,
          code:         diagnosis.medical_code,
          description:  diagnosis.short_description,
          impression:   diagnosis.impression,
          level:        diagnosis.diagnosis_level,
          created_on:   diagnosis.pms_created_on,
          record_type:  diagnosis.record_type,

          // work around for pagination issue
          diagnosis_index: index
        }

        state.diagnoses.push(data);
      });
    },

    /* ############################# SEPARATOR ############################# */

    clearStoreData(state) {
      state.id = null;
      state.code = '';
      state.description = '';
      state.impression = '';
      // state.level = '';
      state.diagnoses = [];
      state.active = null;
      state.diagnosis_index = '';

      state.activeIndex = null;
    },

    /* ############################# SEPARATOR ############################# */

    // CODES
    setFavoriteCodes(state) {
      state.fave_codes = JSON.parse(localStorage.getItem('favorite_codes'))
    },

    /* ############################# SEPARATOR ############################# */

    addToMostUsed(state, code) {
      var codes = state.codes // all codes
      var used_codes = JSON.parse(localStorage.getItem('most_used_codes')) // mosed used codes from localStorage

      // if used_codes has data
      if (used_codes && used_codes.length > 0) {
        let index = used_codes.findIndex(item=>item.id==code.id)

        // if code is already recorded
        if (index >= 0) {
          used_codes[index].uses++
          Diagnosis.updateMostUsed({medical_code_id: used_codes[index].id, uses: used_codes[index].uses});
          let sorted_codes = used_codes.sort((a,b) => a.uses - b.uses)
          localStorage.setItem('most_used_codes', JSON.stringify(sorted_codes))
          state.used_codes = sorted_codes
        }

        // if code is not yet recorded
        else {
          // find code in original list
          let index = codes.findIndex(item=>item.id==code.id)

          // if code exists
          if (index >= 0) {
            codes[index].uses = 1
            Diagnosis.updateMostUsed({medical_code_id: codes[index].id, uses: codes[index].uses});
            var new_code = codes[index]
            used_codes.push(new_code)
            localStorage.setItem('most_used_codes', JSON.stringify(used_codes))
            state.used_codes = used_codes
          }
        }
      }

      // if used_codes is empty
      else {
        // find code in original list
        let index = codes.findIndex(item=>item.id==code.id)

        // if code exists
        if (index >= 0) {
          let new_used_codes = [] // create new array
          codes[index].uses = 1 // add initial number of uses
          Diagnosis.updateMostUsed({medical_code_id: codes[index].id, uses: codes[index].uses});
          new_used_codes.push(codes[index]) // add code to array
          localStorage.setItem('most_used_codes', JSON.stringify(new_used_codes))
          state.used_codes = new_used_codes
        }
      }
    },

    /* ############################# SEPARATOR ############################# */

    addToFavorites(state, code) {
      var codes = JSON.parse(localStorage.getItem('favorite_codes'))
      codes.push(code)
      localStorage.setItem('favorite_codes', JSON.stringify(codes))
      state.fave_codes = codes
    },

    /* ############################# SEPARATOR ############################# */

    removeFromFavorites(state, id) {
      var codes = JSON.parse(localStorage.getItem('favorite_codes'))
      var index = codes.findIndex(item => item.id == id)
      codes.splice(index, 1)
      localStorage.setItem('favorite_codes', JSON.stringify(codes))
      state.fave_codes = codes
    },

    /* ############################# SEPARATOR ############################# */

    createFavorites(state, code) {
      var new_fave_codes = []
      new_fave_codes.push(code)
      localStorage.setItem('favorite_codes', JSON.stringify(new_fave_codes))
      state.fave_codes = new_fave_codes
    },

    /* ############################# SEPARATOR ############################# */

    setCodes(state, codes) {
      state.codes = codes
    },

    /* ############################# SEPARATOR ############################# */

    setDiagnosisId(state, {index, id}) {
      state.diagnoses[index].id = id
    }
  },

  /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

  actions: {
    async save({ commit, getters }, {case_id, consult_id}) {
      getters.diagnoses.forEach(async (diagnosis, key) => {
        const payload = {
          medical_code:       diagnosis.code,
          short_description:  diagnosis.description,
          impression:         diagnosis.impression,
          diagnosis_level:    diagnosis.level,
          record_type:        diagnosis.record_type
        }

        let response;
        if (diagnosis.id == null) {
          payload.patient_case_id = case_id
          payload.case_consultation_id = consult_id
          response = await Diagnosis.create(payload);
          console.log("[diagnosis/save]", response, payload, key, response.data.id);
          // fix to avoid duplicate saved data on second save
          commit('setDiagnosisId', { index: key, id: response.data.id })
        } else {
          response = await Diagnosis.update(diagnosis.id, payload);
          console.log("[diagnosis/update]", response, diagnosis.medical_code, diagnosis.id);
        }
      });
      
      // delete removed items
      if (getters.removed_items.length) {
        getters.removed_items.forEach(async diagnosis => {
          let response = await Diagnosis.delete(diagnosis.id);
          console.log("[diagnosis/delete_removed_items]", response);
        });
      }
    },

    /* ############################# SEPARATOR ############################# */

    async compiled_diagnoses({ getters }, {case_id}) {
      let compiled_diagnoses = [];

      getters.diagnoses.forEach(async (diagnosis) => {
        if(diagnosis.record_type == "current") {
          let payload = {
            medical_code:       diagnosis.code,
            short_description:  diagnosis.description,
            impression:         diagnosis.impression,
            diagnosis_level:    diagnosis.level,
            record_type:        diagnosis.record_type,
            id:                 diagnosis.id,
            patient_case_id:    case_id
          }

          compiled_diagnoses.push(payload);
        }
      });

      return compiled_diagnoses;
    },

    /* ############################# SEPARATOR ############################# */

    async delete(state, diagnoses) {
      if (diagnoses) {
        diagnoses.forEach(async diagnosis => {
          let response = await Diagnosis.delete(diagnosis.id);
          console.log("[diagnosis/delete]", response);
        });
      }
    },

    /* ############################# SEPARATOR ############################# */

    // CODES
    async fetchCodes(state, {per_page=null, page=null, search=null}) {
      var response = null;

      if(search == null) {
        response = await Medicine.getCodes(per_page, page);
        state.commit('setCodes', response.data.data)
        state.commit('setLastPage', response.data.last_page)
      } else {
        response = await Medicine.getCodes(per_page, page, search);
        state.commit('setCodes', response.data.data)
        state.commit('setLastPage', response.data.last_page)
      }
    },
    
    /* ############################# SEPARATOR ############################# */

    async searchCode(state, search) {
      var response = await Medicine.searchCode(search);
      state.commit('setCodes', response.data.data)
      state.commit('setLastPage', response.data.last_page)
    },

    /* ############################# SEPARATOR ############################# */

    updateFavorites({commit}, code) {
      var codes =  JSON.parse(localStorage.getItem('favorite_codes'))
      
      if (codes && codes.length > 0) {
        let index = codes.findIndex(item => item.id == code.id)
        
        if (index < 0) {
          commit('addToFavorites', code)
          Diagnosis.updateFavorites({medical_code: code, type: 'add'});
        } else {
          commit('removeFromFavorites', codes[index].id)
          Diagnosis.updateFavorites({medical_code: code, type: 'delete'});
        }
      } else {
        commit('createFavorites', code)
        Diagnosis.updateFavorites({medical_code: code, type: 'add'});
      }
    },

    async getFavoritesMedicalCodes (state) {
      let response = await Diagnosis.getFavorites()
      localStorage.setItem('favorite_codes', JSON.stringify(response.data.data));
      state.commit('setFavoriteCodes');
    }
  }
})